import { CONDITION_MAP, type FilterStack, type GraphQLFilter } from "./types"

const log = (logger: () => void) => {
  console.group("[Authentified Retool Scripts]")
  console.group("[transformFilterStackToGraphQLFilter]")
  logger()
  console.groupEnd()
  console.groupEnd()
}

/**
 * This function transforms Retool's filter stack to a GraphQL filter object or array
 *
 * @param filterStack
 * @returns string[] | null
 */
export const transformFilterStackToGraphQLFilter = (filterStack: FilterStack, extra?: GraphQLFilter) => {
  if (!filterStack && !extra) {
    log(() => console.debug("No filter stack or extra provided"))
    return null
  }

  if (!filterStack && extra) {
    log(() => console.debug("Returning extra"))
    return extra
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const convertColumnToFilter = (operator: string, value: any) => {
    if (operator.indexOf(".") !== -1) {
      const parts = operator.split(".")
      parts.push(value)

      // @ts-expect-error
      return parts.reduceRight((acc, currentVal) => {
        return {
          [currentVal]: acc,
        }
      })
    }

    return {
      [operator]: value,
    }
  }

  const transformFilter = (filterStack?: FilterStack[]): GraphQLFilter[] => {
    return filterStack
      ?.map((filter) => {
        if (["and", "or"].includes(filter.operator)) {
          return {
            [filter.operator.toUpperCase()]: transformFilter(filter.filters),
          } as unknown as GraphQLFilter
        }

        const operator = CONDITION_MAP[filter.operator as keyof typeof CONDITION_MAP]
        const columnId = filter.columnId

        if (!operator || !columnId) {
          return null
        }

        if (operator === "isSet") {
          return convertColumnToFilter(columnId, { isSet: true })
        }

        if (operator === "isNotSet") {
          return convertColumnToFilter(columnId, { isSet: false })
        }

        if (filter.operator === "isFalse") {
          filter.value = false
        }

        if (filter.operator === "isTrue") {
          filter.value = true
        }

        if (filter.value === null || typeof filter.value === "undefined") {
          return null
        }

        if (operator === "in") {
          return {
            OR: [
              convertColumnToFilter(columnId, {
                [operator]: filter.value
                  ?.toString()
                  ?.split(",")
                  ?.map((v) => v.trim()),
              }),
              convertColumnToFilter(columnId, {
                startsWith: filter.value,
              }),
            ],
          }
        }

        return convertColumnToFilter(columnId, {
          [operator]: filter.value,
        }) as unknown as GraphQLFilter
      })
      .filter((filter) => !!filter) as GraphQLFilter[]
  }

  const filters = transformFilter(filterStack.filters)

  if (extra) {
    filters.push(extra)
  }

  log(() =>
    console.debug("result", {
      [filterStack.operator.toUpperCase()]: filters,
    })
  )

  return {
    [filterStack.operator.toUpperCase()]: filters,
  }
}
